export const init = root => {
  const animateBars = () => {
    root.querySelectorAll('[data-row]').forEach((row, i) => {
      setTimeout(() => {
        row.querySelectorAll('[data-bar]').forEach(el => {
          el.style.translate = '0';
        });
      }, i * 150);
    });
  };

  const firstRow = root.querySelector('[data-row]');

  if (firstRow.getBoundingClientRect().top < window.innerHeight * 0.7) {
    animateBars();
    return;
  }

  const observer = new IntersectionObserver(
    ([entry], obs) => {
      if (entry.isIntersecting) {
        obs.disconnect();
        animateBars();
      }
    },
    { rootMargin: '-70% 0px 0px 0px' },
  );

  observer.observe(firstRow);
};
